export default "__VITE_ASSET__cd9a1399__"